<template>
  <div style="margin-bottom: 10%">
    <breadcrumb v-bind:path2="orderDetail.SONum"></breadcrumb>
    <div class="account">
      <div class="main-content">
        <!-- login  -->
        <div v-show="loggedIn===true" class="page-width">
          <div class="section-header text-center">
            <h1>{{ $t('orderDetail') }}</h1>
            <p>
              <router-link to="/account">{{ $t('returnAccount') }}</router-link>
            </p>
            </div>
          <div class="grid">
            <div class="grid__item medium-up--two-thirds">
              <!-- sales order details -->
              <h2>{{ $t('orderNo') }} {{orderDetail.SONum}}</h2>
              <p>{{ $t('placedOn') }}: {{ moment(orderDetail.CreateTime).format('MM/DD/YY HH:mm') }}</p>
              <!-- <p>{{ $t('estimateDeliveryDate') }}: {{getDate(orderDetail.DispatchDate)}}</p> -->
              <table class="responsive-table">
                <thead>
                  <tr v-if='orderDetail.Carrier==="xpo"'>
                    <th>{{ $t('sku') }}</th>
                    <th>{{ $t('palletQty') }}</th>
                    <th>{{ $t('weight') }}</th>
                    <th>{{ $t('length') }}</th>
                    <th>{{ $t('width') }}</th>
                    <th>{{ $t('height') }}</th>
                    <th>{{ $t('carrierCommDesc') }}</th>
                    <th>{{ $t('total') }}</th>
                  </tr>
                  <tr v-else>
                    <th>{{ $t('sku') }}</th>
                    <th>{{ $t('quantity') }}</th>
                    <th>{{ $t('weight') }}</th>
                    <th>{{ $t('length') }}</th>
                    <th>{{ $t('width') }}</th>
                    <th>{{ $t('height') }}</th>
                    <th>{{ $t('carrierCommDesc') }}</th>
                    <th>{{ $t('total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-if='orderDetail.Carrier==="xpo"'
                    v-for="(item, index) in filterLines(orderDetail.lines, false)"
                    data-index="index"
                    :key="index"
                    class="responsive-table__row">
                    <td data-label="RefNum">{{item.RefNum}}11</td>
                    <td data-label="PalletQuantity">{{item.PalletQuantity}}</td>
                    <td data-label="PalletWeight">{{item.PalletWeight}}</td>
                    <td data-label="PalletWidth">{{item.PalletWidth}}</td>
                    <td data-label="PalletLength">{{item.PalletLength}}</td>
                    <td data-label="PalletHeight">{{item.PalletHeight}}</td>
                    <td data-label="Remark">{{item.Remark}}</td>
                    <td data-label="TotalPrice">${{getAmount(item.TotalPrice)}}</td>
                  </tr>
                  <tr
                    v-else
                    v-for="(item, index) in filterLines(orderDetail.lines, false)"
                    data-index="index"
                    :key="index"
                    class="responsive-table__row">
                    <td data-label="RefNum">{{item.RefNum}}</td>
                    <td data-label="Quantity">{{item.Quantity}}</td>
                    <td data-label="BoxWeight">{{item.BoxWeight}}</td>
                    <td data-label="BoxWidth">{{item.BoxWidth}}</td>
                    <td data-label="BoxLength">{{item.BoxLength}}</td>
                    <td data-label="BoxHeight">{{item.BoxHeight}}</td>
                    <td data-label="Remark">{{item.Remark}}</td>
                    <td data-label="TotalPrice">${{getAmount(item.TotalPrice)}}</td>
                  </tr>
              </tbody>
              <tfoot>
                <tr v-for="(item, index) in filterLines(orderDetail.lines, true)">
                  <td colspan='7' class='small--hide'>{{item.Description}}</td>
                  <td data-label="Description">${{getAmount(item.TotalPrice)}}</td>
                </tr>
                <!-- <tr class="responsive-table__row">
                  <td colspan='7' class='small--hide'>{{ $t('subtotal') }}</td>
                  <td data-label="Subtotal">${{getAmount(orderDetail.TotalPrice)}}</td>
                </tr> -->
                <!-- <tr>
                  <td colspan='7' class='small--hide'>{{ $t('shippingStandardShipping') }}</td>
                  <td data-label="Shipping">${{getAmount(orderDetail.Delivery)}}</td>
                </tr> -->
                <tr v-show="orderDetail.Savings>0.00">
                  <td colspan='7' class='small--hide'>{{ $t('discount') }}</td>
                  <td data-label="Savings">-${{getAmount(orderDetail.Savings)}}</td>
                </tr>
                <!-- <tr>
                  <td colspan='7' class='small--hide'>{{ $t('tax') }}</td>
                  <td data-label="Tax">${{getAmount(orderDetail.TaxAmount)}}</td>
                </tr> -->
                <tr>
                  <td colspan='7' class='small--hide'>{{ $t('total') }}</td>
                  <td data-label="Total">${{getAmount(orderDetail.GrandTotal)}}</td>
                </tr>
              </tfoot>
            </table>
            <!-- end sales order details -->
          </div>
          <div class="grid__item medium-up--one-third">
            <hr class="medium-up--hide">
              <h3>{{ $t('addressInformation') }}</h3>
              <p>
                <strong>{{ $t('shipFromAddress') }}:</strong><br>
                {{orderDetail.FullShipFrom}}
                <br><br>
                <strong>{{ $t('shipToAddress') }}:</strong><br>
                {{orderDetail.FullShipTo}}
              </p>
              <p>
                <strong>{{ $t('paymentStatus') }}:</strong>
                {{orderDetail.PaymentStatus}}
                <br>
                <strong>{{ $t('fulfillmentStatus') }}:</strong>
                {{orderDetail.SaleStatus}}
              </p>
              <div v-if='(orderDetail.IsMobile===false) && (orderDetail.IsOutbound===true) && (orderDetail.Carrier==="xpo")'>
                <button class="btn" @click="viewQuote(orderDetail.SalesOrder_id, $event)">
                  <span>{{ $t("viewQuote") }}</span>
                </button>
                <button class="btn" @click="createBol(orderDetail.SalesOrder_id, $event)">
                  <span>{{ $t("createBolCharge") }}</span>
                </button>
                <button class="btn" @click="printBol(orderDetail.SalesOrder_id, $event)">
                  <span>{{ $t("printBol") }}</span>
                </button>
                <button class="btn" @click="openPickupCreateModal()">
                  <span>{{ $t("createPickup") }}</span>
                </button>
                <button class="btn" @click="getPickup(orderDetail.SalesOrder_id, $event)">
                  <span>{{ $t("getPickup") }}</span>
                </button>
                <button class="btn" @click="getTracking(orderDetail.SalesOrder_id, $event)">
                  <span>{{ $t("xpoTracking") }}</span>
                </button>
              </div>
              <!-- <p>
                {{orderDetail.Shipping_Address.FirstName}} {{orderDetail.Shipping_Address.LastName}}
                <br>
                {{orderDetail.Shipping_Address.Telephone}}
                <br>
                {{orderDetail.Shipping_Address.Street}}
                <br>
                {{orderDetail.Shipping_Address.City}} {{orderDetail.Shipping_Address.State}}
                <br>
                {{orderDetail.Shipping_Address.Country}}
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- pickup create modal -->
    <el-dialog
      v-bind:title="$t('createPickup')"
      :visible.sync="pickupCreateVisible"
      @close="closePickupCreateModal"
      class="modal"
    >
      <el-form ref="timeForm" :model="timeForm">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item v-bind:label="$t('pickupDate')" prop="xpoDate">
              <el-date-picker
                v-model="timeForm.xpoDate"
                type="date"
                format="MM/dd/yyyy"
                placeholder="Pick a day"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-bind:label="$t('pickupReadytime')" prop="xpoReadyTime">
              <el-time-picker
                v-model="timeForm.xpoReadyTime"
                format="HH:mm"
                placeholder="Pick a time"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item v-bind:label="$t('pickupClosetime')" prop="xpoCloseTime">
              <el-time-picker
                v-model="timeForm.xpoCloseTime"
                format="HH:mm"
                placeholder="Pick a time"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <button class="place btn" @click="createPickup(timeForm, orderDetail.SalesOrder_id, $event)">
          {{ $t("submit") }}
        </button>
      </el-form>
    </el-dialog>
    <!-- end pickup create modal -->
    
    <!-- get pickup modal -->  
    <el-dialog
      v-bind:title="$t('pickupInfo')"
      :visible.sync="pickupVisible"
      @close="closePickupModal"
      class="modal"
    >
      <div v-if='pickupInfo'>
        <span>{{ $t("pickupDate") }}: </span>
        <span>{{moment(pickupInfo.pkupDate).format('MMM D, YYYY h:mm A')}}</span><br/>
        <span>{{ $t("readyTime") }}: </span>
        <span>{{moment(pickupInfo.readyTime).format('MMM D, YYYY h:mm A')}}</span><br/>
        <span>{{ $t("closeTime") }}: </span>
        <span>{{moment(pickupInfo.closeTime).format('MMM D, YYYY h:mm A')}}</span><br/><br/><br/>
        <span>{{ $t("Shipper") }}: </span><br/>
        <span>{{ $t("name") }}: </span>
        <span>{{ pickupInfo.shipper.name }}</span><br/>
        <span>{{ $t("address") }}: </span>
        <span>{{ pickupInfo.shipper.addressLine1 + cityName + stateCd + postalCd + countryCd }}</span><br/>
        <span>{{ $t("phone") }}: </span>
        <span>{{ pickupInfo.shipper.phone.phoneNbr }}</span><br/>
      </div>
    </el-dialog>
    <!-- end get pickup modal -->
    
    <!-- tracking modal -->
    <el-dialog
      :visible.sync="trackingVisible"
      @close="closeTrackigModal"
      class="modal">
      <el-tabs v-model="activeName"  type="border-card">
        <!-- Shipment Detail -->
        <el-tab-pane class="tab" v-bind:label="$t('shipmentDetail')" name="first">
          <div v-if='trackingInfo'>
            <table class="xpo-table" cellspacing="0" cellpadding="0" v-bind:style="{border: 'none'}">
              <tr>
                <th>{{ $t("pickupLocation") }}</th>
                <th>{{ $t("deliveryLocation") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{ trackingInfo.shipperAddr.name }}</span></br>
                  <span class="info">{{ trackingInfo.shipperAddr.addressLine1 + ', '
                    + trackingInfo.shipperAddr.cityName + ', '
                    + trackingInfo.shipperAddr.stateCd + ', '
                    + trackingInfo.shipperAddr.postalCd + ', '
                    + trackingInfo.shipperAddr.countryCd }}
                  </span>
                </td>
                <td>
                  <span class="info">{{ trackingInfo.consigneeAddr.name }}</span></br>
                  <span class="info">{{ trackingInfo.consigneeAddr.addressLine1 + ', '
                    + trackingInfo.consigneeAddr.cityName + ', '
                    + trackingInfo.consigneeAddr.stateCd + ', '
                    + trackingInfo.consigneeAddr.postalCd + ', '
                    + trackingInfo.consigneeAddr.countryCd }}
                  </span>
                </td>
              </tr>
              
              <tr>
                <th>{{ $t("consigneeSignature") }}</th>
                <th>{{ $t("consigneeDate") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{ trackingInfo.dlvrSigNameTxt }}</span>
                </td>
                <td>
                  <span class="info">{{ moment(trackingInfo.finalDlvrDate).format('MMM D, YYYY') }}</span>
                </td>
              </tr>
              
              <tr>
                <th>{{ $t("billTo") }}</th>
                <th>{{ $t("pickupId") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{ trackingInfo.billToAddr.name }}</span></br>
                  <span class="info">{{ trackingInfo.billToAddr.addressLine1 + ', '
                    + trackingInfo.billToAddr.cityName + ', '
                    + trackingInfo.billToAddr.stateCd + ', '
                    + trackingInfo.billToAddr.postalCd + ', '
                    + trackingInfo.billToAddr.countryCd }}
                  </span>
                </td>
                <td>
                </td>
              </tr>
              
              <tr>
                <th>{{ $t("transitTime") }}</th>
                <th>{{ $t("xpoService") }}</th>
              </tr>
              <tr>
                <td>
                  <span v-if='trackingInfo.estdDlvrDate' class="info">
                    <span class="info">{{ moment(trackingInfo.estdDlvrDate).format('MMM D, YYYY') }}</span>
                  </span>
                </td>
                <td>
                  <span class="info">{{ trackingInfo.serviceTypeCd }}</span>
                </td>
              </tr>
              
              <tr>
                <th>{{ $t("pickupDate") }}</th>
                <th>{{ $t("pickupTime") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{ moment(trackingInfo.pkupDate).format('MMM D, YYYY') }}</span>
                </td>
                <td>
                  <span class="info">{{ moment(trackingInfo.pkupDate).format('h:mm A') }}</span>
                </td>
              </tr>
              
              <tr>
                <th>{{ $t("pickupContact") }}</th>
                <th>{{ $t("contactPhone") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{ trackingInfo.dlvrAppt.apptContact.contactFirstName }}</span>
                </td>
                <td>
                  <span class="info">{{ trackingInfo.dlvrAppt.apptContact.telephone[0].phoneNbr }}</span>
                </td>
              </tr>
              
              <tr>
                <th colspan="2">Pickup details / special instructions</th>
              </tr>
              <tr>
                <td colspan="2">
                  <span v-if='trackingInfo.dlvrAppt.apptNote.commentTypeCd' class="info">
                    {{ trackingInfo.dlvrAppt.apptNote.commentTypeCd }}
                  </span>
                </td>
              </tr>
              
              <tr>
                <th colspan="2">Commodities</th>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="info">{{ trackingInfo.commodityDescription }}</span>
                </td>
              </tr>
              
              <tr>
                <th colspan="2">Customer reference number(s)</th>
              </tr>
              <tr>
                <td colspan="2">
                  <span class="info">{{ trackingInfo.suppRef[0].reference }}</span></br>
                  <span class="info">{{ trackingInfo.suppRef[1].reference }}</span></br>
                  <span class="info">{{ trackingInfo.suppRef[2].reference }}</span>
                </td>
              </tr>
            </table>
            
          </div>
        </el-tab-pane>

        <!-- Appoitment Detail -->
        <el-tab-pane class="tab" v-bind:label="$t('appoitmentDetail')" name="second">
          <div v-if='trackingInfo.dlvrAppt'>
            <table class="xpo-table" cellspacing="0" cellpadding="0" v-bind:style="{border: 'none'}">
              <tr>
                <th>{{ $t("scheduleDate") }}</th>
                <th>{{ $t("scheduleAt") }}</th>
              </tr>
              <tr>
                <td>
                  <span v-if='trackingInfo.dlvrAppt.startDateTime' class="info">{{moment(trackingInfo.dlvrAppt.startDateTime).format('MMM D, YYYY')}}</span><br/>
                  <span v-if='trackingInfo.dlvrAppt.endDateTime' class="info">
                    {{moment(trackingInfo.dlvrAppt.startDateTime).format('h:mm A') + ' - ' +  moment(trackingInfo.dlvrAppt.endDateTime).format('h:mm A')}}
                  </span><br/>
                </td>
                <td>
                  <span class="info">{{ trackingInfo.destSic.name }}</span></br>
                  <span class="info">{{ trackingInfo.destSic.cityName + ', '+ trackingInfo.destSic.stateCd}}</span>
                </td>
              </tr>
              <tr>
                <th>{{ $t("contactInfo") }}</th>
                <th>{{ $t("callTime") }}</th>
              </tr>
              <tr>
                <td>
                  <span class="info">{{trackingInfo.dlvrAppt.apptContact.contactFirstName}}</span><br/>
                  <span class="info">{{trackingInfo.dlvrAppt.apptContact.telephone[0].phoneNbr}}</span>
                </td>
                <td>
                  <span v-if='trackingInfo.dlvrAppt.callDateTime' class="info">{{moment(trackingInfo.dlvrAppt.callDateTime).format('MMM D, YYYY h:mm A')}}</span><br/>
                </td>
              </tr>
            </table>
          </div>
          <div v-else v-bind:style="{padding: '20px'}">
            <span>{{ $t("noAppoitmentDetail") }}</span>
          </div>
        </el-tab-pane>
        
        <!-- Documents -->
        <el-tab-pane class="tab" v-bind:label="$t('documents')" name="third">
          <h3>{{ $t("documents") }}</h3>

          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.BL" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('BL')">Bill of Lading</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.BL}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.DR" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('DR')">DR</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.DR}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.DRR" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('DRR')">DRR</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.DRR}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.CUST" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('CUST')">CUST</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.CUST}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.IR" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('IR')">IR</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.IR}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.LOA" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('LOA')">LOA</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.LOA}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.NCIC" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('NCIC')">NCIC</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.NCIC}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.WI" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('WI')">WI</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.WI}}</span>
          </div>
          <div v-bind:style="{marginBottom: '15px'}" v-if="this.xpoFileLinks.WRFO" >
            <span v-bind:style="{color: 'blue', fontWeight: 'bold', cursor: 'pointer'}" @click="onClick('WRFO')">WRFO</span>
            <span v-bind:style="{marginLeft: '20px', fontWeight: 'bold'}">{{this.xpoFileTimestamp.WRFO}}</span>
          </div>

        </el-tab-pane>
        
        <!-- History -->
        <el-tab-pane class="tab" v-bind:label="$t('history')" name="forth">
          <div v-if='trackingHistory.length===0'>
            <span>{{ $t("noHistory") }}</span>
          </div>
          <div v-else v-bind:style="{padding: '20px'}">
            <div v-for="(item,index) in trackingHistory" data-index="index" :key="index">
              <span class="history-header">{{moment(item.eventHdr.eventTmst).format('MMM D, YYYY h:mm A')}}</span>
              <div class="history-box">
                <span>{{item.eventHdr.eventDesc}}</span><br/>
                <a :href="item.eventOccrdLoc.locationLink" target="_blank">
                  {{item.eventOccrdLoc.cityName + ', ' + item.eventOccrdLoc.stateCd}}
                </a>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- end tracking modal -->
    
    <!-- XPO Quote modal -->
    <el-dialog
      v-bind:title="$t('XPOQuote')"
      :visible.sync="xpoQuoteVisible"
      @close="closeXPOModal"
      class="modal"
      width='80%'
    >
      <table class="responsive-table">
        <tr>
          <!-- <th>Pricing Breakdown</th> -->
          <th>Quote Created</th>
          <th>Quote Confirmation #</th>
          <!-- <th>Payment Terms</th> -->
          <th>Transit Days</th>
          <th>From</th>
          <th>To</th>
          <th>Shipping Date</th>
          <th>Estimated Delivery</th>
          <!-- <th>Pricing Breakdown</th> -->
        </tr>
        <tr>
          <!-- <td>{{xpoString.rateQuote && 'Standard Quote for ' + xpoString.rateQuote.shipmentInfo.bill2Party.address.name}}</td> -->
          <td>{{xpoString.rateQuote && moment(xpoString.rateQuote.quoteCreateDate).format('MMM D, YYYY h:mm A') + ' PDT'}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.confirmationNbr}}</td>
          <!-- <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.paymentTermCd}}</td> -->
          <td>{{xpoString.transitTime && xpoString.transitTime.transitDays}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.shipper.address.postalCd + ' ' + xpoString.rateQuote.shipmentInfo.shipper.address.stateCd + ' (' + xpoString.rateQuote.shipmentInfo.shipper.address.countryCd + ')'}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.consignee.address.postalCd + ' ' + xpoString.rateQuote.shipmentInfo.consignee.address.stateCd + ' (' + xpoString.rateQuote.shipmentInfo.consignee.address.countryCd + ')'}}</td>
          <td>{{xpoString.rateQuote && moment(xpoString.rateQuote.shipmentInfo.shipmentDate).format('MMM Do, YYYY')}}</td>
          <td>{{xpoString.transitTime && moment(xpoString.transitTime.estdDlvrDate).format('MMM Do, YYYY')}}</td>
          <!-- <td>{{xpoString.rateQuote && 'Standard Quote for ' + xpoString.rateQuote.shipmentInfo.bill2Party.address.name}}</td> -->
        </tr>
      </table>
      
      <table class="responsive-table">
        <tr>
          <th>Class</th>
          <th>Units</th>
          <th>Length(in)</th>
          <th>Width(in)</th>
          <th>Height(in)</th>
          <th>Weight(lbs)</th>
        </tr>
        <tr>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].nmfcClass}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].pieceCnt}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.length}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.width}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].dimensions.height}}</td>
          <td>{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.commodity[0].grossWeight.weight}}</td>
        </tr>
      </table>
      <!-- <div v-bind:style="{fontSize: '18px', fontWeight: 'bold', marginBottom: '15px', marginTop: '10px'}">Total Net Charge:  ${{xpoString.rateQuote && xpoString.rateQuote.totCharge[0].amt}}</div> -->
      <div v-bind:style="{fontSize: '12px', marginBottom: '15px', color: 'gray'}">{{xpoString.rateQuote && xpoString.rateQuote.shipmentInfo.comment}}</div>
    </el-dialog>
    <!-- end XPO Quote modal -->
  </div>
</template>

<script>
  import { mapActions, mapState, mapMutations} from 'vuex';
  import moment from 'moment';
  import axios from "axios";
  
  import breadcrumb from '../../components/breadcrumb';
  import Router from '../../router';
  import {
    GET_QUOTE_URL, YING_BOL_URL, GET_PICKUP_URL, TRACKING_URL, XPO_TOKEN_URL,
    XPO_DOC_URL,
  } from '../../api/url.js';

  export default {
    name: "order",
    loaded: false,
    components: { breadcrumb },
    data(){
      return{
        moment: moment,
        path2: '',
        // orderDetail: {
        //   SONum: '',
        //   CreateTime: '',
        //   DispatchDate:'',
        //   Sales_Order_Line: [],
        // 
        //   TotalPrice: '',
        //   Delivery:'',
        //   Savings: '',
        //   TaxAmount: '',
        //   GrandTotal: '',
        // 
        //   Shipping_Address: {},
        //   PaymentStatus:'',
        //   SaleStatus:'',
        // },
        xpoQuoteVisible: false,
        xpoString: {},
        
        pickupCreateVisible: false,
        timeForm: {
          xpoDate: null,
          xpoReadyTime: null,
          xpoCloseTime: null,
        },

        xpoFileLinks: {
          BL: null,
          DR: null,
          DRR: null,
          CUST: null,
          IR: null,
          LOA: null,   
          NCIC: null,
          WI: null,
          WRFO: null,
        },
        xpoFileTimestamp: {
          BL: null,
          DR: null,
          DRR: null,
          CUST: null,
          IR: null,
          LOA: null,   
          NCIC: null,
          WI: null,
          WRFO: null,
        },
        xpoToken: null,
      
        pickupVisible: false,
        pickupInfo: '',
        
        trackingVisible: false,
        trackingInfo: '',
        trackingHistory: [],
        activeName: 'first',
        tabs: [
          { name: 'shipmentDetail', displayName: '全部',},
          { name: 'appoitmentDetail', displayName: '等待付款',},
          { name: 'documents', displayName: '处理中',},
          { name: 'history', displayName: '已运送',},
        ],
      }
    },
    methods:{
      ...mapActions('orders', ['fetchSODetails','fetchSIDetails']),
      ...mapMutations('orders', ['updateActiveOrder']),
      // 
      // fetchOrderDetail(orderId) {
      //   console.log('fetchOrderDetail: ');
      //   this.fetchSODetails(orderId)
      //   .then(res => {
      //     console.log('res: ', res.data);
      //     this.orderDetail = res.data;
      //     console.log('this.orderDetail: ', this.orderDetail);
      // 
      //   })
      //   .catch(err => {
      //     console.log('fetchOrderDetail error: ', err);
      //   })
      // }, 
      getDate(value) {
        return moment(value).format('MMMM Do YYYY');
      },
      getAmount(price) {
        return parseFloat(price).toFixed(2); 
      },
      filterLines(lines, isFee) {
        // filter language
        let filterLines = lines.filter(line => {
          return line.IsFee === isFee;
        });
        return filterLines;
      },
      openPickupCreateModal() {
        this.pickupCreateVisible = true;
        this.timeForm= {
          xpoDate: null,
          xpoReadyTime: null,
          xpoCloseTime: null,
        }
      },
      closePickupCreateModal(event) {
        event.preventDefault();
        this.pickupCreateVisible = false;
      },
      closePickupModal(event) {
        event.preventDefault();
        this.pickupVisible = false;
      },
      closeXPOModal(event) {
        event.preventDefault();
        this.xpoQuoteVisible = false;
        this.xpoString = {};
      },
      closeTrackigModal(event) {
        event.preventDefault();
        this.trackingVisible = false;
        this.trackingInfo = {};
      },
      viewQuote(id, event) {
        event.preventDefault();
        const token = localStorage.getItem('token');
        axios.get(
          GET_QUOTE_URL + id,
          { headers: {Authorization: `JWT ${token}` },},
        ).then((res) => {
          this.xpoString = res.data;
          this.xpoQuoteVisible = true;
        })
        .catch(err => {
          alert(JSON.stringify(err.request.response));
        })
      },
      createBol(id, event) {
        event.preventDefault();
        let data = null;
        const token = localStorage.getItem('token');
        axios.post(
          YING_BOL_URL + id,
          data,
          { headers: {Authorization: `JWT ${token}` },},
        ).then((response) => {
          alert('BOL has been created!');
        })
        .catch(err => {
          alert(JSON.stringify(err.request.response.errors.moreInfo[0].message));
        })
      },
      printBol(id, event) {
        event.preventDefault();
        const token = localStorage.getItem('token');
        return axios.get(
          YING_BOL_URL + id,
          {
            headers: { Authorization: `JWT ${token}` },
            responseType: 'blob',
          },
        )
        .then((res) => {
          const FILE = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = FILE;
          link.setAttribute('download', 'file.pdf');
          document.body.appendChild(link);
          link.click();
        }, (err) => {
          alert("Could not fetch BOL");
          console.log('ERROR IN response', err);
        });
      },
      createPickup(form, id, event) {
        event.preventDefault();
        const token = localStorage.getItem('token');
        const date = moment(form.xpoDate).format().split("T")[0];
        const readyTime = moment(form.xpoReadyTime).format().split("T")[1];
        const closeTime = moment(form.xpoCloseTime).format().split("T")[1];
        
        let data = {
          pickup: moment(form.xpoDate).format(),
          ready: date+'T'+readyTime,
          close: date+'T'+closeTime,
        };
        
        axios.post(
          (GET_PICKUP_URL + id),
          data,
          {
            headers: { Authorization: `JWT ${token}` },
          },
        ).then((response) => {
          alert("Pickup Created: " + JSON.stringify(response.data, null, 2));
          this.pickupCreateVisible = false;
        })
        .catch(err => {
          alert(JSON.stringify(err.request.response));
        })
      },
      getPickup(id, event) {
        event.preventDefault();
        const token = localStorage.getItem('token');
        axios.get(
          (GET_PICKUP_URL + id),
          {
            headers: { Authorization: `JWT ${token}` },
          },
        ).then((response) => {
          this.pickupInfo = response.data;
          this.pickupVisible = true;
        })
        .catch(err => {
          console.log('err:', err);
          alert(JSON.stringify(err.request.response));
        })
      },

      onClick(type) {
        this.xpoFileLinks[type].click();
        // this.fileLink.click();
      },

      base64toBlob(base64Data, contentType) {
          contentType = contentType || '';
          var sliceSize = 1024;
          var byteCharacters = atob(base64Data);
          var bytesLength = byteCharacters.length;
          var slicesCount = Math.ceil(bytesLength / sliceSize);
          var byteArrays = new Array(slicesCount);

          for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
              var begin = sliceIndex * sliceSize;
              var end = Math.min(begin + sliceSize, bytesLength);

              var bytes = new Array(end - begin);
              for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                  bytes[i] = byteCharacters[offset].charCodeAt(0);
              }
              byteArrays[sliceIndex] = new Uint8Array(bytes);
          }
          return new Blob(byteArrays, { type: contentType });
      },

      getTracking(id, event) { 
        event.preventDefault();
        const token = localStorage.getItem('token');
        const infoRequest = axios.get(
          `${TRACKING_URL}${id}`,
          { headers: { Authorization: `JWT ${token}`} }
        );
        const historyRequest = axios.get(
          `${TRACKING_URL}${id}?events=True`,
          { headers: { Authorization: `JWT ${token}`} }
        );
        
        axios.all([infoRequest, historyRequest])
         .then(axios.spread((infoResponse, historyResponse) => { 
           this.trackingInfo = infoResponse.data.shipmentStatusDtls[0];
           this.trackingHistory = historyResponse.data.shipmentTrackingEvent;
           this.trackingVisible = true;
           const proNbr = historyResponse.data.proNbr;
           axios.get(
             XPO_TOKEN_URL,
             { headers: { Authorization: `JWT ${token}` }},
           ).then((res) => {
             this.xpoToken = res.data.token;
             
             this.fetchXPOFiles('BL');
             this.fetchXPOFiles('DR');
             this.fetchXPOFiles('DRR');
             this.fetchXPOFiles('CUST');
             this.fetchXPOFiles('IR');
             this.fetchXPOFiles('LOA');             
             this.fetchXPOFiles('NCIC');
             this.fetchXPOFiles('WI');
             this.fetchXPOFiles('WRFO');             
           })
           .catch(err => {
             alert(JSON.stringify(err));
           })
         })).catch(error => {
           console.log('error: ', error);
           alert('error on getting Tracking.');
           // alert(JSON.stringify(error.request.response));
         });
      },

      fetchXPOFiles(type) {
            // imageType: BL, DR, DRR, CUST, IR, LOA, NCIC, WI, WRFO
             axios.get(
              `${XPO_DOC_URL}216430675/imaged-docs?&imageFormat=PDF&imageType=${type}&multiPartResp=false`,
              { headers: { Authorization: `Bearer ${this.xpoToken}`} },
              ).then((res) => {
                let x1 = res.data.split('"base64Data":"')[1].split('","fileName')[0];
                let x2 = this.base64toBlob(x1, 'pdf');
                // console.log('blob', x2);
                var fileURL = window.URL.createObjectURL(new Blob([x2]));
                this.xpoFileLinks[type] = document.createElement('a');
                this.xpoFileLinks[type].href = fileURL;
                this.xpoFileLinks[type].setAttribute('download', type+'.pdf');
                document.body.appendChild(this.xpoFileLinks[type]);
                // this.fileLink.click();

                // extract other info (time stamp)
                let unixTime = res.data.split('"scanDate":')[1].split('}]}}')[0];
                this.xpoFileTimestamp[type] = new Date(unixTime * 1000);
                this.xpoFileTimestamp[type] = moment(this.xpoFileTimestamp[type]).format('MM/DD/YY HH:mm')
                // console.log("timestamp", this.xpoFileTimestamp[type]);

             })
             .catch(err => {
               console.log('err: ', err);
               // alert(JSON.stringify(err.request.response));
             })
      },
    },
    computed: mapState({
      loggedIn: state => state.auth.loggedIn,
      orderTimeFrame: state => state.orders.orderTimeFrame,
      orderDetail: state => state.orders.orderDetail,
      activeOrder: state => state.orders.activeOrder,
    }),
    watch: {
      '$route': {
        // this.$router.go(this.$route);
        handler(newVal) {
          const params = this.$route.params.order_id;
          const orderId = this.activeOrder || params;
          this.fetchSODetails(orderId)
          .then(() => {
            this.updateActiveOrder(orderId);
          });
        }
      }
    },
    mounted: function() {
      const orderId = this.$route.params.order_id;
      this.fetchSODetails(this.$route.params.order_id);
    },
    created: function(){

    }
  }
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/order.less";
@import "../../assets/css/account.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/orderDetail.vue